// A name must contain at least one letter; digits-only or symbols-only input is rejected.
export const HAS_LETTER_REGEX = /\p{L}/u;
export const INVALID_NAME_MESSAGE =
  "Enter a valid name with at least one letter";

export const FAX_NUMBER_PATTERN = /^\d{10}$/;
export const FAX_NUMBER_LENGTH_MESSAGE =
  "Fax number must be exactly 10 digits.";

/** Why a name is invalid, or undefined when it passes. */
export const nameIssue = (name: string): string | undefined =>
  HAS_LETTER_REGEX.test(name) ? undefined : INVALID_NAME_MESSAGE;

/** Inline message for an input the last Save & Sign found empty. */
export const REQUIRED_FIELD_MESSAGE = "This field is required";
export const REQUIRED_SELECTION_MESSAGE = "Select at least one option";
export const REQUIRED_ANSWER_MESSAGE = "Select an option or add a note";
